import { render, staticRenderFns } from "./LamsBaseLegalProcedureLevel.vue?vue&type=template&id=42addd02&scoped=true&"
import script from "./LamsBaseLegalProcedureLevel.vue?vue&type=script&lang=js&"
export * from "./LamsBaseLegalProcedureLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42addd02",
  null
  
)

export default component.exports